import {
  createHashRouter,
  Navigate,
} from "react-router-dom";

// import Splash from '../../features/Splash/Splash'
import Login from '../../features/Login';
import Home from '../../features/home/home';
import Dashboard from '../../features/dashboard/dashboard';
import Organisation from '../../features/organisation/organisation';
import RoutePath from "./routes.path";
import { HomeTwoTone } from "@ant-design/icons";
import { ErrorBoundary } from "../../features/home/ErrorBoundary";

//@ts-ignore
import {startCase} from 'lodash';
import User from "../../features/user/user";
import UpsertUser from "../../features/user/upsertUser";
import { getUserById, getUserChat } from "../../features/user/loader";
import ConfigureUser from "../../features/user/configure";
import ViewUserData from "../../features/user/viewUser";
import path from "path";
import KPI from "../../features/kpi/kpi";
import Query from "../../features/query/query";
import { getAllKpis } from "../../features/dashboard/loader";


export const route = [
  // {
  //   path: "/",
  //   Component: Splash,
  // },
  {
    path: RoutePath.login,
    Component: Login,
    handle: { crumb: 'Login' },
  },
  {
    path: "/",
    element: (<Home />),
    handle: { crumb: (<HomeTwoTone />) },
    ErrorBoundary: ErrorBoundary,
    children: [
      {
        index: true,
        Component: ()=>(<Navigate to={RoutePath.dashboard} replace />),
      },
      {
        path: RoutePath.dashboard,
        Component: Dashboard,
        loader: getAllKpis,
        handle: { crumb: 'Dashboard' },
      },
      {
        path: RoutePath.query,
        Component: Query,
        handle: { crumb: 'Query' },
      },
      {
        path: RoutePath.organisation,
        handle: { crumb: 'Organisation' },
        children: [
          {
            index: true,
            Component: Organisation,
            handle: { crumb: 'List' },
          },

        ]
      },
      {
        path: RoutePath.user,
        handle: { crumb: 'User' },
        children: [
          {
            index: true,
            Component: User,
            handle: { crumb: 'List' },
          },
          {
            path: RoutePath.add,
            Component: UpsertUser,
            handle: { crumb: 'New' },
          },
          {
            path: RoutePath.update, 
            handle: { crumb: (match: any)=>(startCase(match.params.mode))},
            children: [
              {
                index: true,
                Component: UpsertUser,
                loader: getUserById,
                handle: { crumb: 'Info' },
              }, 
              {
                path: RoutePath.userConfig,
                handle: { crumb: 'Config' },
                Component: ConfigureUser,
                loader: getUserById,
              },
            ]
          },
          {
            path: RoutePath.viewData,
            Component: ViewUserData,
            loader: getUserById,
            handle: { crumb: 'Data' },
          }

        ]
      },
      {
        path: RoutePath.kpi,
        Component: KPI,
        handle: { crumb: 'KPI' },
      }
    ]
  },


]

export default createHashRouter(route);